import React from 'react';
import { 
  User, 
  FileText, 
  CreditCard, 
  Shield, 
  Settings, 
  LogOut,
  ChevronRight,
  Check,
  Circle
} from 'lucide-react';
import { MainLayout } from './MainLayout';
import { useApp } from './AppContext';

export function MyProfile() {
  const { setCurrentScreen, logout, idCheckState, updateIDCheckState } = useApp();

  const menuItems = [
    {
      id: 'profile-data',
      label: 'Profile Data',
      icon: User,
      status: 'complete',
      showArrow: true
    },
    {
      id: 'billing-data',
      label: 'Billing Detail',
      icon: CreditCard,
      status: 'complete',
      showArrow: true
    },
    {
      id: 'id-check',
      label: 'ID Check',
      icon: Shield,
      status: idCheckState.status === 'Completed' ? 'complete' : 'incomplete',
      showArrow: true
    },
    {
      id: 'settings',
      label: 'Setting',
      icon: Settings,
      status: 'none',
      showArrow: true
    },
    {
      id: 'logout',
      label: 'Log out',
      icon: LogOut,
      status: 'none',
      showArrow: false
    }
  ];

  const handleMenuClick = (itemId: string) => {
    if (itemId === 'logout') {
      logout();
    } else if (itemId === 'id-check') {
      // Reset navigation context when accessing from profile
      updateIDCheckState({ navigationContext: 'initial' });
      
      // State-based navigation logic
      if (idCheckState.status === 'Pending') {
        setCurrentScreen('id-terms');
      } else {
        setCurrentScreen('id-result');
      }
    } else {
      setCurrentScreen(itemId as any);
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'complete':
        return <Check size={16} className="text-[var(--ucm-success-green)]" />;
      case 'incomplete':
        return (
          <div className="flex space-x-1">
            <Circle size={4} className="text-[var(--ucm-warning-orange)] fill-current" />
            <Circle size={4} className="text-[var(--ucm-warning-orange)] fill-current" />
            <Circle size={4} className="text-[var(--ucm-warning-orange)] fill-current" />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <MainLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[var(--ucm-text-dark)]">
          My Profile
        </h1>
      </div>

      <div className="space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.id}
              className="bg-white rounded-xl p-4 shadow-[0_2px_8px_rgba(0,0,0,0.06)] cursor-pointer hover:shadow-[0_4px_16px_rgba(0,0,0,0.08)] transition-shadow"
              onClick={() => handleMenuClick(item.id)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  {getStatusIcon(item.status)}
                  <span className="font-medium text-[var(--ucm-text-dark)]">
                    {item.label}
                  </span>
                </div>
                
                {item.showArrow && (
                  <ChevronRight size={16} className="text-[var(--ucm-text-light)]" />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </MainLayout>
  );
}